export default {
  AUTH: 'auth',
  AUTH_BASIC: 'auth-basic',
  PUBLIC: 'public',
  PUBLIC_BASIC: 'public-basic',
  TAKEOVER: 'takeover',
};
